<template>
  <div class="page-cancellation">
    <div scroll-with-animation scroll-y class="content">
      <div class="content-inner">
        <div class="info">
          您正在申请注销当前账号
        </div>
        <div class="table-list">
          <div class="table-head">为保障您的权益，我们在此提醒您，您的账号应满足：</div>
          <div class="table-content">
            <div class="line">
              <div class="num">1. </div>
              <div class="text">不存在未了结的权利义务、或任何其他因为注销该库迪会员账号会产生纠纷或争议的情况；</div>
            </div>
            <div class="line">
              <div class="num">2. </div>
              <div class="text">不存在任何未完结的交易或订单；</div>
            </div>
            <div class="line">
              <div class="num">3. </div>
              <div class="text"
                >账号下的资产或虚拟权益已结清，包括但不限于任何积分、优惠券、代金券等，或您自行选择放弃该账号下所有资产或虚拟权益。</div
              >
            </div>
          </div>
        </div>
        <div class="table-list">
          <div class="table-head">申请注销后，我们将清除账号内的所有信息，包括但不限于：</div>
          <div class="table-content">
            <div class="line">
              <div class="num">1. </div>
              <div class="text">个人资料：包括但不限于账号头像、昵称、手机号码、关联第三方账号信息等；</div>
            </div>
             <div class="line">
              <div class="num">2. </div>
              <div class="text">历史信息：包括但不限于订单记录、积分记录、收货地址信息、发票信息等。</div>
            </div>
          </div>
        </div>
        <div class="table-list">
          <div class="table-head">账号注销后，相同手机号仍可重新注册，但系统不可恢复您之前的任何个人资料和历史信息。</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
    }
  },
  computed: {
  },
  methods: {
    
  }
}
</script>

<style lang="scss" scoped>
.page-cancellation {
  background-color: #fff;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
  .content {
    // height: 10px;
    flex: 1 1 auto;
    &-inner {
    padding: 24px 32px;
    max-height: 99%;
    overflow: auto;
      .info {
        font-size: 28px;
        color: #3a3b3c;
        line-height: 48px;
        .phone {
          padding: 0 8px;
          font-size: 28px;
          font-weight: 500;
          color: #3a3b3c;
          line-height: 48px;
        }
      }
      .table-list {
        margin-top: 24px;
        border-radius: 8px;
        border: 1px solid #EEEEEE99;
        .table-head {
          background: #f5f6f7;
          padding: 26px 24px;
          font-size: 26px;
          font-weight: 600;
          color: #3a3b3c;
          line-height: 36px;
        }
        .table-content {
          padding: 24px;
          .line {
            display: flex;
            align-items: flex-start;
            justify-content: flex-start;
            & + .line {
              margin-top: 8px;
            }
            .num {
              width: 34px;
              flex: 0 0 auto;
              font-size: 24px;
              font-weight: 600;
              color: #3a3b3c;
              line-height: 48px;
              color: #A52337;
            }
            .text {
              font-size: 24px;
              font-weight: 400;
              color: #3a3b3c;
              line-height: 48px;
              .notes {
                font-size: 22px;
                color: #5e5e5e;
                line-height: 48px;
                & + .notes {
                  margin-top: 4px;
                }
              }
            }
          }
        }
      }
    }
  }
  .footer {
    flex: 0 0 auto;
    padding: 16px 32px;
    padding-bottom: calc(constant(safe-area-inset-bottom) + 16px);
    padding-bottom: calc(env(safe-area-inset-bottom) + 16px);
    .next-btn {
      width: 100%;
      height: 80px;
      background: #A52337;
      border-radius: 8px;
      text-align: center;
      font-size: 28px;
      font-weight: 500;
      color: #ffffff;
      line-height: 80px;
    }
  }
}
</style>
